/**
 * Modals and side panels stack — the budget plans modal opens the category ones on top of
 * itself, a berth's panel opens over My marinas and its Edit modal over that — so only the
 * overlay on top answers Escape. Without this a single Escape closes the whole stack, and
 * the work in progress behind the top one goes with it.
 */
const openOverlays: object[] = [];

/** Puts `overlay` on top of the stack; call the returned function to take it off again. */
export const pushOverlay = (overlay: object) => {
  openOverlays.push(overlay);
  return () => {
    const index = openOverlays.indexOf(overlay);
    if (index !== -1) openOverlays.splice(index, 1);
  };
};

export const isTopOverlay = (overlay: object) => openOverlays[openOverlays.length - 1] === overlay;
